import classNames from "classnames";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

import { pluralizeIfNecessary } from "@ascendnow/shared";
import { LocationIcon, UsersIcon } from "../../AscIcons";
import AscTag from "../../AscTag/AscTag";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscTimeBookCard.module.scss";
import { AscColorTagTypes } from "../../AscTag/AscTag.types";
dayjs.extend(relativeTime);

type AscTimeBookCardJobLocationType = "remote";

export interface AscTimeBookCardProps {
  title: string;
  city: string;
  logoUrl?: string;
  country: string;
  numberOfJobs?: number;
  jobLocationType?: AscTimeBookCardJobLocationType;
  rangeOfPeople: string;
  tags?: { tag: string; type?: AscColorTagTypes }[];
  fullWidth?: boolean;
  onClick?: () => void;
}

export default function AscTimeBookCard({
  title,
  numberOfJobs = 0,
  rangeOfPeople,
  tags,
  city,
  logoUrl,
  country,
  fullWidth,
  onClick,
}: AscTimeBookCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground, { [styles.fullWidth]: fullWidth })}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      imageClassName={styles.cardImage}
      coverImageUrl={logoUrl}
      onClick={onClick}
      title={
        <div className={styles.header}>
          <div className={styles.headerText}>
            <h5 className={classNames(styles.cardTitle)}>{title}</h5>
            {numberOfJobs ? (
              <AscTag
                label={`${numberOfJobs} ${pluralizeIfNecessary(
                  "Job",
                  numberOfJobs
                )}`}
              />
            ) : null}
          </div>
        </div>
      }
      contentClassName={styles.content}
    >
      <div className={styles.topContent}>
        <span className={styles.textContent}>
          <LocationIcon className={styles.icon} />
          <span className={styles.label}>
            {country} / {city}
          </span>
        </span>

        <span className={styles.textContent}>
          <UsersIcon className={styles.icon} />
          <span className={styles.label}>{rangeOfPeople}</span>
        </span>
      </div>
      <div className={styles.bottomContent}>
        {tags?.map((tag, index) => (
          <AscTag key={index} label={tag.tag} />
        ))}
      </div>
    </AscGenericCard>
  );
}
